import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {DtoImportObjectContextEntry} from "../../../../../core/shared/dto/dto.import.object.context.entry";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";


@Component({
    selector: 'object-ticket-group-filter',
    templateUrl: './object-ticket-group-filter.component.html',
    standalone: false
})
export class ObjectTicketGroupFilterComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    selectionTicketGroupWidget: WidgetData;
    selectionTicketTypeWidget: WidgetData;
    selectionAgentPoolWidget: WidgetData;
    selectionAgentWidget: WidgetData;
    restrictAgentPoolWidget: WidgetData;
    restrictAgentWidget: WidgetData;
    selectionStatusWidget: WidgetData;
    selectionUrgencyWidget: WidgetData;
    ticketGroupFilterWidget: WidgetData;

    /**
     * On Object Change.
     */
    onObjectChanged() {
        this.importObjectContext = new DtoImportObjectContext([new DtoImportObjectContextEntry(this.objectIdentifier.objectType, this.objectIdentifier.objectId)]);
        this.refreshWidgets();
        this.initialized = true;
    }

    refreshWidgets() {
        this.refreshSelectionAgentPoolWidget();
        this.refreshSelectionTicketTypeWidget();
        this.refreshSelectionTicketGroupWidget();
        this.refreshSelectionAgentWidget();
        this.refreshRestrictionAgentPoolWidget();
        this.refreshRestrictionAgentWidget();
        this.refreshSelectionStatusWidget();
        this.refreshSelectionUrgencyWidget();
        this.refreshTicketGroupWidget();
    }

    refreshSelectionTicketGroupWidget() {
        this.selectionTicketGroupWidget = WidgetFactory.createWidgetList(
            'object.ticket.group.filter.selection.ticket.group',
            // TM-1000001438: Fixed translation per Patrick's screenshot
            "Einschränken auf Ticketgruppen",
            'chip',
            'list',
            'entity',
            'tm.TicketGroupFilterSelectionTicketGroup',
            'Keine Auswahl',
            new ObjectRequestList(
                true,
                [FilterCriteria.create('ticketGroupFilter',FilterCriteria.cOperatorEqual,this.objectIdentifier.objectId)],
                []),
            new WidgetDataParam("linkedEntityTargetAttributeName", "ticketGroupDtoName")
        );
    }

    refreshSelectionTicketTypeWidget() {
        this.selectionTicketTypeWidget = WidgetFactory.createWidgetList(
            'object.ticket.group.filter.selection.ticket.type',
            // TM-1000001438: Fixed translation per Patrick's screenshot
            "Einschränken auf Tickettypen",
            'chip',
            'list',
            'entity',
            'tm.TicketGroupFilterSelectionTicketType',
            'Keine Auswahl',
            new ObjectRequestList(
                true,
                [FilterCriteria.create('ticketGroupFilter',FilterCriteria.cOperatorEqual,this.objectIdentifier.objectId)],
                []
            ),
            new WidgetDataParam("linkedEntityTargetAttributeName", "ticketTypeDtoName")
        );
    }

    refreshSelectionAgentPoolWidget() {
        this.selectionAgentPoolWidget = WidgetFactory.createWidgetList(
            'object.ticket.group.filter.selection.agent.pool',
            // TM-1000001438: Fixed translation per Patrick's screenshot (was "Abteilung Auswahl")
            "Einschränken auf Agentenpool",
            'chip',
            'list',
            'entity',
            'tm.TicketGroupFilterSelectionAgentPool',
            'Keine Auswahl',
            new ObjectRequestList(
                true,
                [FilterCriteria.create('ticketGroupFilter',FilterCriteria.cOperatorEqual,this.objectIdentifier.objectId)],
                []),
            new WidgetDataParam("linkedEntityTargetAttributeName", "agentPoolDtoName")
        );
    }

    refreshSelectionAgentWidget() {
        this.selectionAgentWidget = WidgetFactory.createWidgetList(
            'object.ticket.group.filter.selection.agent',
            // TM-1000001438: Fixed translation per Patrick's screenshot
            "Einschränken auf Agenten",
            'chip',
            'list',
            'entity',
            'tm.TicketGroupFilterSelectionAgent',
            'Keine Auswahl',
            new ObjectRequestList(
                true,
                [FilterCriteria.create('ticketGroupFilter',FilterCriteria.cOperatorEqual,this.objectIdentifier.objectId)],
                []),
            new WidgetDataParam("linkedEntityTargetAttributeName", "agentDtoName")
        );
    }

    refreshRestrictionAgentPoolWidget() {
        this.restrictAgentPoolWidget = WidgetFactory.createWidgetList(
            'object.ticket.group.filter.restriction.agent.pool',
            // TM-1000001438: Fixed translation per Patrick's screenshot (was "Abteilung Einschränkung")
            "Ausschließen von Agentenpool",
            'chip',
            'list',
            'entity',
            'tm.TicketGroupFilterRestrictionAgentPool',
            'Keine Auswahl',
            new ObjectRequestList(
                true,
                [FilterCriteria.create('ticketGroupFilter',FilterCriteria.cOperatorEqual,this.objectIdentifier.objectId)],
                []),
            new WidgetDataParam("linkedEntityTargetAttributeName", "agentPoolDtoName")
        );
    }

    refreshRestrictionAgentWidget() {
        this.restrictAgentWidget = WidgetFactory.createWidgetList(
            'object.ticket.group.filter.restriction.agent',
            // TM-1000001438: Fixed translation per Patrick's screenshot
            "Ausschließen von Agenten",
            'chip',
            'list',
            'entity',
            'tm.TicketGroupFilterRestrictionAgent',
            'Keine Auswahl',
            new ObjectRequestList(
                true,
                [FilterCriteria.create('ticketGroupFilter',FilterCriteria.cOperatorEqual,this.objectIdentifier.objectId)],
                []),
            new WidgetDataParam("linkedEntityTargetAttributeName", "agentDtoName")
        );
    }

    refreshSelectionStatusWidget() {
        this.selectionStatusWidget = WidgetFactory.createWidgetList(
            'object.ticket.group.filter.selection.status',
            // TM-1000001438: Fixed translation per Patrick's screenshot
            "Einschränken auf Status",
            'chip',
            'list',
            'entity',
            'tm.TicketGroupFilterSelectionStatus',
            'Keine Auswahl',
            new ObjectRequestList(
                true,
                [FilterCriteria.create('ticketGroupFilter',FilterCriteria.cOperatorEqual,this.objectIdentifier.objectId)],
                []),
            new WidgetDataParam("linkedEntityTargetAttributeName", "status")
        );
    }

    refreshSelectionUrgencyWidget() {
        this.selectionUrgencyWidget = WidgetFactory.createWidgetList(
            'object.ticket.group.filter.selection.urgency',
            // TM-1000001438: Fixed translation per Patrick's screenshot
            "Einschränken auf Dringlichkeit",
            'chip',
            'list',
            'entity',
            'tm.TicketGroupFilterSelectionUrgency',
            'Keine Auswahl',
            new ObjectRequestList(
                true,
                [FilterCriteria.create('ticketGroupFilter',FilterCriteria.cOperatorEqual,this.objectIdentifier.objectId)],
                []),
            new WidgetDataParam("linkedEntityTargetAttributeName", "urgency")
        );
    }

    refreshTicketGroupWidget() {
        this.ticketGroupFilterWidget = WidgetFactory.createWidgetListEntityBasicQl('object.ticket.group.config.ticket.group.filter.simple', 'Ticketgruppen Filter', 'tm.TicketGroupFilter', [FilterCriteria.create('e.id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)]);
    }
    //
    // refreshSelectionTicketGroupWidget() {
    //     const filter = [FilterCriteria.create('e.ticketGroupFilterId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)];
    //
    //     const query: QlQueryDto = {
    //         name: "getPageContent",
    //         type: "view",
    //         start: {
    //             type: "entity",
    //             name: "tm.TicketGroupFilterSelectionTicketGroup",
    //             as: "e"
    //         },
    //         filters: filter
    //     };
    //
    //     const request = QlWidgetFactory.createWidgetRequest(query);
    //     //
    //     // this.selectionTicketGroupWidget = WidgetFactory.createWidgetListEntityBasicQl(
    //     //     'object.ticket.group.filter.selection.ticket.group',
    //     //     'Selection Ticket Group',
    //     //     'tm.TicketGroupFilterSelectionTicketGroup',
    //     //     null,
    //     //     [],
    //     //     false,
    //     //     new WidgetDataParam('linkedEntityTargetAttributeName', 'ticketGroupDtoName')
    //     // );
    //     this.selectionTicketGroupWidget = WidgetFactory.createWidgetList(
    //         'object.ticket.group.filter.selection.ticket.group',
    //         'Selection Ticket Group',
    //         'chip',
    //         'list',
    //         'ql',
    //         null,
    //         null,
    //         request,
    //         new WidgetDataParam('linkedEntityTargetAttributeName', 'ticketGroupDtoName')
    //     );
    //
    //
    //     this.selectionTicketGroupWidget.uiComponent = 'chip';
    // }
    //
    // refreshSelectionTicketTypeWidget() {
    //     this.selectionTicketTypeWidget = WidgetFactory.createWidgetListEntityBasicQl('object.ticket.group.filter.selection.ticket.type', 'Selection Ticket Type', 'tm.TicketGroupFilterSelectionTicketType', [FilterCriteria.create('e.ticketGroupFilterId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], [], false, new WidgetDataParam('linkedEntityTargetAttributeName', 'ticketTypeDtoName'));
    // }
    //
    // refreshSelectionAgentPoolWidget() {
    //     this.selectionAgentPoolWidget = WidgetFactory.createWidgetListEntityBasicQl('object.ticket.group.filter.selection.agent.pool', 'Selection Agent Pool', 'tm.TicketGroupFilterSelectionAgentPool', [FilterCriteria.create('e.ticketGroupFilterId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], [], false, new WidgetDataParam('linkedEntityTargetAttributeName', 'agentPoolDtoName'));
    // }
    //
    // refreshSelectionAgentWidget() {
    //     this.selectionAgentWidget = WidgetFactory.createWidgetListEntityBasicQl('object.ticket.group.filter.selection.agent', 'Selection Agent', 'tm.TicketGroupFilterSelectionAgent', [FilterCriteria.create('e.ticketGroupFilterId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], [], false, new WidgetDataParam('linkedEntityTargetAttributeName', 'agentDtoName'));
    // }
    //
    // refreshRestrictionAgentPoolWidget() {
    //     this.restrictAgentPoolWidget = WidgetFactory.createWidgetListEntityBasicQl('object.ticket.group.filter.restriction.agent.pool', 'Restriction Agent Pool', 'tm.TicketGroupFilterRestrictionAgentPool', [FilterCriteria.create('e.ticketGroupFilterId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], [], false, new WidgetDataParam('linkedEntityTargetAttributeName', 'agentPoolDtoName'));
    // }
    //
    // refreshRestrictionAgentWidget() {
    //     this.restrictAgentWidget = WidgetFactory.createWidgetListEntityBasicQl('object.ticket.group.filter.restriction.agent', 'Restriction Agent', 'tm.TicketGroupFilterRestrictionAgent', [FilterCriteria.create('e.ticketGroupFilterId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], [], false, new WidgetDataParam('linkedEntityTargetAttributeName', 'agentDtoName'));
    // }
    //
    // refreshSelectionStatusWidget() {
    //     this.selectionStatusWidget = WidgetFactory.createWidgetListEntityBasicQl('object.ticket.group.filter.selection.status', 'Selection Status', 'tm.TicketGroupFilterSelectionStatus', [FilterCriteria.create('e.ticketGroupFilterId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], [], false, new WidgetDataParam('linkedEntityTargetAttributeName', 'status'));
    // }
    //
    // refreshSelectionUrgencyWidget() {
    //     this.selectionUrgencyWidget = WidgetFactory.createWidgetListEntityBasicQl('object.ticket.group.filter.selection.urgency', 'Selection Urgency', 'tm.TicketGroupFilterSelectionUrgency', [FilterCriteria.create('e.ticketGroupFilterId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], [], false, new WidgetDataParam('linkedEntityTargetAttributeName', 'urgency'));
    // }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}